import React from "react"
import { Field } from "formik"
import CheckboxInput from "@components/form/inputs/CheckboxInput"
import { hookOnChange } from "../../utils"

const CheckboxField = ({
  name,
  label,
  onChange = (...args: any) => {},
  className,
  disabled,
}: any) => (
  <Field name={name}>
    {({ field }) => (
      <CheckboxInput
        {...field}
        label={label}
        onChange={hookOnChange(field, onChange)}
        className={className}
        disabled={!!disabled}
      />
    )}
  </Field>
)

export default CheckboxField
